<template>
  <ValidationObserver v-slot="validator">
    <div class="modal-card" v-bind="dirtySite">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ modalTitle }}
        </p>
        <button @click="closeModal" type="button" class="close-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </header>
      <section class="modal-card-body">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|max:255"
          name="Site Name"
        >
          <b-field
            label="Site Name"
            :message="errors[0]"
            :type="errors.length ? 'is-danger' : undefined"
          >
            <b-input
              v-model="dirtySite.name"
              placeholder="Name of institution or place to run data collection period"
            ></b-input>
          </b-field>
        </ValidationProvider>

        <b-field label="Address">
          <b-input
            v-model="dirtySite.address"
            placeholder="Address of institution or place to run data collection period"
          ></b-input>
        </b-field>

        <b-field label="Description" class="no-bottom-margin">
          <b-input
            v-model="dirtySite.description"
            type="textarea"
            placeholder="Description of the site (example : opening hours, phone number)"
          ></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary is-rounded"
          @click="
            validator.validate().then((validated) => {
              if (validated === false) return;
              addSite();
            })
          "
        >
          Add Site
        </button>
      </footer>
    </div>
  </ValidationObserver>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Site } from '@/store/modules/projects/types/projects.types';
import { cloneDeep as _cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class SiteModal extends Vue {
  @Prop()
  public modalTitle!: string;

  @Prop()
  public siteDetail!: Site;

  // @ts-ignore
  public dirtySite: Site = {
    id: 0,
    name: '',
    address: '',
    description: '',
    isIdentifierRequired: false,
  };

  public addSite() {
    this.$emit('addNewSite', this.dirtySite);
    this.$emit('close');
  }

  public closeModal() {
    this.$emit('close');
  }

  public mounted() {
    this.dirtySite = _cloneDeep(this.siteDetail);
  }
}
</script>
<style module></style>
